import { create } from 'zustand';

/**
 * "This page has one ask, and the bar's Sign in slot is where it is made."
 *
 * Same courier as `owner-store`: the bar is mounted once by the root layout and
 * cannot be handed props by a page, so the prebuilt page announces its ask on
 * mount and takes it back on the way out. `null` is the ordinary Sign in.
 */
export interface BarAsk {
  label: string;
  /** False while the page is not ready to be claimed; the pill then says why. */
  ready: boolean;
  waiting: string | null;
  /** The recruit-word reply the DM link came from, for the sign-in the pill opens. */
  inviteReply: string | null;
  /** The claim itself. Resolves to an error to show, or null when the page navigated. */
  run: () => Promise<string | null>;
}

interface BarAskState {
  ask: BarAsk | null;
  setAsk: (ask: BarAsk | null) => void;
}

export const useBarAsk = create<BarAskState>((set) => ({
  ask: null,
  setAsk: (ask) => set({ ask }),
}));
